// Overlay.js
import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: var(--surface-overlay-scrim);
  z-index: 90;
`;
